module.exports = __webpack_public_path__ + "img/lvyou.ff5b5a09.jpg";